import gradient from './gradient';

export default function(context, item, value) {
  return (value.id) ?
    gradient(context, value, item.bounds) :
    value;
}



// WEBPACK FOOTER //
// ./~/vega-scenegraph/src/util/canvas/color.js